export default __webpack_public_path__ + "static/media/dashboard-classinfo.bab7c6ad.svg";